module.exports = __webpack_public_path__ + "static/media/greenspot.f92a1dc3.png";